<template>
  <div ref="myEcharts" :style="{ height, width }"></div>
</template>
<script>
import { ref, onMounted } from "vue";
import * as echarts from "echarts";
export default {
  name: "baseBar",
  props: {
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: String,
      default: "100%",
    },
    left2Data: {
      type: Object,
      default: () => {},
    }
  },
  setup(props) {
    // console.log(props);
    const myEcharts = ref(null);
    const chart = new InitChart(props, myEcharts);
    onMounted(() => {
      // console.log(props)
      chart.init(props.left2Data,props.name,props.color);
      
    });
    return {
      myEcharts,
    };
  },
};
class InitChart {
  constructor(props, myEcharts) {
    this.props = props;
    this.myEcharts = myEcharts;
    this.state = {
      chart: null,
    };
  }

  init() {
    this.state.chart && this.destory();
    this.state.chart = echarts.init(this.myEcharts.value);

   var captions = ['一', '二', '三', '四', '五', '六', '七'];
   var values = ['81', '65', '76', '84','81', '65', '76'];

    this.state.chart.setOption({
         tooltip: {
            trigger: "axis",
            axisPointer: {
               type: 'none'
            },
            position: function (point, params, dom, rect, size) { // 提示框位置
               let x = 0;
               let y = 0;
               if (point[0] + size.contentSize[0] + 10 > size.viewSize[0]) {
                  x = point[0] - size.contentSize[0] - 10
               } else {
                  x = point[0] + 10
               }
               if (point[1] + size.contentSize[1] + 10 > size.viewSize[1]) {
                  y = point[1] - size.contentSize[1] - 10
               } else {
                  y = point[1] + 10
               }
               return [x, y];
            },
            formatter: params => {
               console.log(params)
               const {
                  name, 
                  data,
               } = params[0];
               return `
                  <div style="font-size: 14px;font-family: Source Han Sans CN-Medium;font-weight: 500;color: #FFFFFF;margin-bottom:12px;">${name}</div>
                  <div style="font-size: 14px;font-family: Source Han Sans CN-Medium;font-weight: 500;color: #FFFFFF;margin-bottom:4px;">销售金额${data} 元</div>
               `
               
            },
         extraCssText: 'opacity: 0.8;background-color:#050F1B;padding:16px;box-shadow: 1px 6px 15px 1px rgba(0,0,0,0.13);border-radius: 4px;filter: blur(undefinedpx);border:none;'
      },
      grid: {
            top: '5%',
            left: '10%',
            right: '5%',
            bottom: '15%',
            // containLabel: true
         },
      xAxis: {
         type: 'category',
         data: captions,
         boundaryGap:false,
         axisTick: {
            show: false //隐藏X轴刻度
         },
         axisLine: {
            lineStyle: {
               color: "#173D42",
               width:2
            }
         },
         axisLabel: {
            show: true,
            textStyle: {
               color:  '#fff', 
               fontSize: 13,
               fontFamily:'Source Han Sans CN-Regular',
            }
         },
      },
      yAxis: {
               name:"吨",
               nameTextStyle: {
                  color: '#5093B8',
                  fontSize: 12,
               },
            axisLabel: {//y轴文字的配置
               color: "#fff",
               margin: 15
            },
               splitLine: {
                  show: false,

               },
                axisLine: {
                  show:true,
                  lineStyle: {
                     type: 'solid',
                     color: '#173D42',
                     width:2
                  }
                }
            },
         series: [{
            type: 'line',
            data: values,
            symbolSize: 2, //标记的大小
             symbol: 'circle',
            areaStyle: {
               color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                  offset: 0,
                  color: 'rgba(4,119,99,0.5)' // 0% 处的颜色
               }, {
                  offset: 0.1,
                  color: 'rgba(24,119,99,0.5)' // 100% 处的颜色
               }, {
                  offset: 0.15,
                  color: 'rgba(24,119,99,0.5)' // 100% 处的颜色
               }, {
                  offset: 0.5,
                  color: 'rgba(24,119,99,0)' // 100% 处的颜色
               }, {
                  offset: 1,
                  color: 'rgba(29,63,120,0)' // 100% 处的颜色
               }], false),
            },
            lineStyle: {
               color: "#047763",
               width: 2,
               shadowColor: 'rgba(29,63,120,0.5)',//设置折线阴影
               shadowBlur: 5,
               shadowOffsetY: 2,
            },
            itemStyle: {
               //折线拐点标志的样式
               color: "#047763",
               borderColor: "#047763",
               borderWidth: 5,
            },
            smooth: 0.4,
            emphasis: {
               scale:1.5
            }
         }]
    });
    window.addEventListener("resize", () => {
      this.state.chart.resize();
    });
  }

  destory() {
    this.state.chart.dispose();
    window.removeEventListener("resize", () => {
      console.log("事件移除");
    });
  }
}
</script>
<style lang="less"></style>
